import { render, staticRenderFns } from "./DatetimeItem.vue?vue&type=template&id=32a1142e"
import script from "./DatetimeItem.vue?vue&type=script&lang=js"
export * from "./DatetimeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports